import Modal from '../../../base/pages/consumption/Modal';

const modal: Modal = {
  noDataTitle: 'Der ausgewählte Bereich enthält keine Daten',
  noDataMessage: ''
};

export default modal;
